




















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CreateManualFeeRequest from '@/models/Products/ProductFees/CreateManualFeeRequest';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({  name: 'ManualFeesDialogForm', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ default: false })
    manualFee: CreateManualFeeRequest

    async beforeMount() {
        await SubTransactionTypesModule.getSubTransactionTypes();
    }

    get subTransactionTypeOptions() {
        return SubTransactionTypesModule.subTransactionTypes;
    }

    get defaultWalletCurrency() {
        return ProductDetailsModule.product.generalSettings.defaultWalletCurrency;
    }

}
